module.exports = __webpack_public_path__ + "c19fca4d0adcc24a1bcc4ae8a0e2f85e.pdf";